module.exports = __webpack_public_path__ + "img/logo.37d8d0d1.png";